<template>
  <v-layout row wrap justify-center>
    <pg-detail
      :title="title"
      :primary_key="primary_key"
      :primary_field="primary_field"
      :deleteProcess="deleteDialog"
      :fab="profil.role == 'ADMIN'"
      @found="selected = [$event]"
      @add="openInputDialog('ADD')"
      @update="openInputDialog('UPDATE')"
      @delete="deleteDialog = true"
    >
      <template slot="detail-content" slot-scope="props">
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-list two-line subheader>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">star</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Nama Divisi</v-list-tile-title>
                  <v-list-tile-sub-title
                    >{{ props.detail.trainer_divisi }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">directions_run</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Total Trainer</v-list-tile-title>
                  <v-list-tile-sub-title
                    >{{ props.detail.total_trainer }}
                    <small>Trainer</small>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
            </v-list>
          </v-flex>
          <v-flex xs12 sm6>
            <v-expansion-panel class="elevation-1" focusable>
              <v-expansion-panel-content :value="true">
                <div slot="header">TRAINER TERKAIT</div>
                <v-subheader v-if="!detailTrainer" class="mb-3">
                  {{ title }} ini tidak memiliki keterkaitan data dengan
                  TRAINER.
                </v-subheader>
                <vue-perfect-scrollbar v-else style="max-height: 400px">
                  <v-list>
                    <v-list-tile
                      v-for="(item, i) in detailTrainer"
                      :key="i"
                      style="border-bottom: 1px solid #eee"
                      v-ripple
                      :to="{
                        name: 'TrainerList',
                        query: { id: item.id_trainer }
                      }"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title>{{
                          item.trainer
                        }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </vue-perfect-scrollbar>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
        </v-layout>
      </template>
    </pg-detail>
    <template v-if="!$route.query.id">
      <v-flex xs12>
        <v-card>
          <v-card-title class="py-2">
            <v-btn
              v-if="profil.role == 'ADMIN'"
              color="green"
              dark
              icon
              @click.stop="openInputDialog('ADD')"
            >
              <v-icon>add</v-icon>
            </v-btn>
            <v-btn
              v-if="profil.role == 'ADMIN'"
              color="blue"
              :disabled="selected.length != 1"
              dark
              icon
              @click.stop="openInputDialog('UPDATE')"
            >
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn
              v-if="profil.role == 'ADMIN'"
              color="red"
              :disabled="selected.length == 0"
              dark
              icon
              @click.stop="deleteDialog = true"
            >
              <v-icon>delete</v-icon>
            </v-btn>
            <json-excel
              :data="selected"
              :export-fields="jsonFields"
              :name="`${$route.name}.xls`"
            >
              <v-btn color="indigo" :disabled="selected.length == 0" dark icon>
                <v-icon>file_download</v-icon>
              </v-btn>
            </json-excel>
            <v-btn
              :color="!filterOn ? 'grey' : 'orange'"
              :disabled="!sourceData.length && !filterOn"
              dark
              icon
              @click.stop="filterDialog = true"
            >
              <v-icon>filter_list</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Pencarian"
              clearable
              single-line
              hide-details
            >
            </v-text-field>
          </v-card-title>

          <v-data-table
            v-if="!$vuetify.breakpoint.xs"
            v-model="selected"
            :headers="headers"
            :items="sourceData"
            :search="search"
            :pagination.sync="pagination"
            :loading="!trainer_divisi_loaded"
            select-all
            item-key="id_trainer_divisi"
            :rows-per-page-items="pages"
            rows-per-page-text="Data/hlm"
            class="elevation-1"
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th>
                  <v-checkbox
                    :input-value="props.all"
                    :indeterminate="props.indeterminate"
                    primary
                    hide-details
                    @click.native="toggleAll"
                  >
                  </v-checkbox>
                </th>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable ',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                    header.align ? `text-xs-${header.align}` : 'text-xs-left'
                  ]"
                  @click="changeSort(header.value)"
                >
                  <v-icon small>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </template>
            <v-progress-linear
              slot="progress"
              color="primary"
              :height="3"
              indeterminate
            >
            </v-progress-linear>
            <template slot="items" slot-scope="props">
              <tr
                :active="props.selected"
                class="nowrap"
                @click="toggleExpand(props)"
              >
                <td style="width: 80px">
                  <v-checkbox
                    :input-value="props.selected"
                    @click.stop="props.selected = !props.selected"
                    primary
                    hide-details
                  >
                  </v-checkbox>
                </td>
                <td>
                  <v-chip
                    small
                    label
                    @click.stop="
                      $router.push({
                        name: $route.name,
                        query: { id: props.item.id_trainer_divisi }
                      })
                    "
                  >
                    {{ props.item.trainer_divisi }}
                  </v-chip>
                </td>
                <td class="text-xs-center">{{ props.item.total_trainer }}</td>
              </tr>
            </template>
            <template
              slot="expand"
              slot-scope="props"
              v-if="$vuetify.breakpoint.xs"
            >
              <v-card
                flat
                :color="$vuetify.dark ? 'grey darken-1' : 'grey lighten-5'"
              >
                <table class="expanded">
                  <tr v-for="(header, i) in headers" :key="`rows-${i}`">
                    <td>{{ header.text }}</td>
                    <td>{{ props.item[header.value] | noEmpty }}</td>
                  </tr>
                </table>
              </v-card>
            </template>
            <template slot="no-data">
              <v-alert
                :value="true"
                :color="trainer_divisi_loaded ? 'warning' : 'info'"
                :icon="trainer_divisi_loaded ? 'warning' : 'info'"
                class="pa-1"
              >
                <span v-if="!trainer_divisi_loaded">Mengambil data...</span>
                <span v-else>Tidak ada data.</span>
              </v-alert>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="warning"
              icon="warning"
              class="pa-1"
            >
              Kata kunci "{{ search }}" tidak ditemukan.
            </v-alert>
          </v-data-table>

          <v-data-iterator
            v-else
            v-model="selected"
            :items="sourceData"
            :pagination.sync="pagination"
            :loading="!trainer_divisi_loaded"
            :search="search"
            select-all
            item-key="id_trainer_divisi"
            :rows-per-page-items="pages"
            rows-per-page-text="Data/hlm"
            row
            wrap
          >
            <v-flex slot="item" slot-scope="props" xs12>
              <v-card>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-checkbox
                      :input-value="props.selected"
                      @click.stop="props.selected = !props.selected"
                      class="ma-0 pa-0"
                      hide-details
                      primary
                    >
                    </v-checkbox>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{
                      props.item.trainer_divisi
                    }}</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn
                      :to="{
                        name: $route.name,
                        query: { id: props.item.id_trainer_divisi }
                      }"
                      fab
                      flat
                      small
                      color="primary"
                    >
                      <v-icon>keyboard_arrow_right</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider></v-divider>
                <v-slide-y-transition>
                  <!-- <div v-show="props.selected"> -->
                  <v-list
                    dense
                    :class="props.selected ? 'secondary white--text' : ''"
                  >
                    <v-list-tile v-for="(header, i) in simpleHeaders" :key="i">
                      <v-list-tile-content>
                        <v-list-tile-title>{{ header.text }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{
                          props.item[header.value] | noEmpty
                        }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                  <!-- </div> -->
                </v-slide-y-transition>
              </v-card>
            </v-flex>
            <template slot="no-data">
              <v-alert
                :value="true"
                color="warning"
                icon="warning"
                class="pa-1"
              >
                <span v-if="status.loading">Loading...</span>
                <span v-else>Tidak ada data.</span>
              </v-alert>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="warning"
              icon="warning"
              class="pa-1"
            >
              Kata kunci "{{ search }}" tidak ditemukan.
            </v-alert>
          </v-data-iterator>
        </v-card>
      </v-flex>

      <pg-form-filter
        :dialog="filterDialog"
        :filterOn="filterOn"
        :filter="filter"
        :source="sourceData"
        :sourceOriginal="sourceOriginal"
        :title="title"
        @close="filterDialog = false"
        @toggle="
          filterOn = !filterOn;
          filterDialog = false;
        "
        @filtered="filterSource = $event"
      >
        <template slot="filter-content" slot-scope="props">
          <v-autocomplete
            append-icon="star"
            attach
            hide-details
            item-text="trainer_divisi"
            item-value="id_trainer_divisi"
            multiple
            :items="trainer_divisi"
            v-model="props.filter.id_trainer_divisi"
            label="Nama Divisi"
          >
          </v-autocomplete>
          <v-range-slider
            v-model="props.filter.total_trainer"
            label="Total Trainer"
            append-icon="directions_run"
            hide-details
            style="margin-top: 40px"
            always-dirty
            :min="props.filter.field.total_trainer[0]"
            :max="props.filter.field.total_trainer[1]"
            thumb-label="always"
          >
          </v-range-slider>
        </template>
      </pg-form-filter>
    </template>

    <pg-form-delete
      :dialog="deleteDialog"
      :selected="selected"
      :title="title"
      :primary_key="primary_key"
      @cancel="deleteDialog = false"
      @deleted="onDeleted"
      action="trainer_divisi/DELETE_TRAINER_DIVISI"
    >
      <template slot="item-detail" slot-scope="props">
        {{ props.item.trainer_divisi }}
      </template>
    </pg-form-delete>

    <trainer-divisi-input
      :dialog="inputDialog"
      :data="selected[0]"
      :title="title"
      :action="inputAction"
      :primary_key="primary_key"
      :primary_field="primary_field"
      @cancel="inputDialog = false"
      @submitted="onSubmitted"
    >
    </trainer-divisi-input>
  </v-layout>
</template>


<script>
import _ from "lodash";
import c from "@/constants";
import JsonExcel from "vue-json-excel";
import PgDetail from "@/components/private/PgDetail";
import PgFormDelete from "@/components/private/PgFormDelete";
import PgFormFilter from "@/components/private/PgFormFilter";
import TrainerDivisiInput from "@/components/pages/input/TrainerDivisiInput";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapState } from "vuex";

const defaultFilter = {
  id_trainer_divisi: [],
  total_trainer: [0, 100],
  field: {
    total_trainer: [0, 100]
  },
  format: {
    id_trainer_divisi: c.FORMAT.options,
    total_trainer: c.FORMAT.number
  }
};

export default {
  name: "trainer-divisi",
  components: {
    JsonExcel,
    VuePerfectScrollbar,
    PgDetail,
    PgFormDelete,
    PgFormFilter,
    TrainerDivisiInput
  },
  data() {
    return {
      // datatable
      headers: [
        { text: "DIVISI", value: "trainer_divisi" },
        { text: "TOTAL TRAINER", value: "total_trainer", align: "center" }
      ],
      pagination: {
        sortBy: "trainer_divisi"
      },
      pages: [7, 10, 25, { text: "Semua", value: -1 }],
      selected: [],
      search: "",
      // dialog
      title: "TRAINER_DIVISI",
      primary_field: "trainer_divisi",
      primary_key: "id_trainer_divisi",
      // delete
      deleteDialog: false,
      // filter
      filterDialog: false,
      filterSource: [],
      filterOn: false,
      filterHelperSourceUpdated: false,
      filter: _.cloneDeep(defaultFilter),
      // input
      inputDialog: false,
      inputAction: "ADD",
      // other
      c: c
    };
  },
  computed: {
    ...mapState(["status"]),
    ...mapState("auth", ["profil"]),
    ...mapState("trainer_divisi", ["trainer_divisi", "trainer_divisi_loaded"]),
    simpleHeaders() {
      return this.headers.filter(h => !["trainer_divisi"].includes(h.value));
    },
    jsonFields() {
      return this.headers.reduce(
        (obj, item) => ((obj[item.text] = item.value), obj),
        {}
      );
    },
    detailTrainer() {
      let result = null;
      if (this.$route.query.id) {
        let trainer = this.$store.state.trainer.trainer.filter(t => {
          return t.id_trainer_divisi == this.$route.query.id;
        });
        if (trainer.length) result = trainer;
      }
      return result;
    },
    sourceOriginal() {
      /* eslint-disable */
      this.filterHelperSourceUpdated = true;
      return _.cloneDeep(this.$store.state.trainer_divisi.trainer_divisi);
    },
    sourceData() {
      let source = _.cloneDeep(this.sourceOriginal);
      if (
        (this.filterOn && !_.isEqual(source, this.filterSource)) ||
        (this.filterHelperSourceUpdated && this.filterSource.length)
      ) {
        source = this.filterSource;
        /* eslint-disable */
        this.filterHelperSourceUpdated = false;
      }
      return source;
    }
  },
  methods: {
    toggleAll() {
      if (this.selected.length == this.sourceData.length) this.selected = [];
      else this.selected = _.cloneDeep(this.sourceData);
    },
    toggleExpand(props) {
      if (this.$vuetify.breakpoint.smAndDown) {
        if (!props.selected) props.expanded = !props.expanded;
        else props.expanded = false;
      } else props.expanded = false;
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    openInputDialog(action) {
      this.inputAction = action;
      this.inputDialog = true;
    },
    onSubmitted(new_id) {
      this.inputDialog = false;
      if (!this.$route.query.id) {
        if (this.inputAction == "UPDATE") {
          setTimeout(() => {
            this.selected = [];
          }, 1000);
        }
      } else {
        if (this.inputAction == "ADD") {
          this.$router.push({
            name: this.$route.name,
            query: { id: new_id }
          });
        }
      }
    },
    onDeleted(selected) {
      this.selected = selected;
      // if all success, then close dialog
      if (!this.selected.length) this.deleteDialog = false;
    }
  },
  mounted() {}
};
</script>
